import * as React from 'react';
import Project from 'src/entities/Project';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import '../Modals.css';
import InvestmentFunnelHeaderComponent
  from 'src/modules/modals/investment-funnel/partials/InvestmentFunnelHeader.component';

export interface SuccessfulInvestmentComponentProps {
  project: Project;
  modalRef?: Modal;
}

class SuccessfulInvestmentComponent extends React.PureComponent<SuccessfulInvestmentComponentProps> {

  public render(): React.ReactNode {
    return (
      <div className="modal-content investment-funnel-modal">
        <InvestmentFunnelHeaderComponent
          logo={this.props.project.company.logo}
          modalRef={this.props.modalRef}
        />
        <div className="modal-body">
          <span className="corrected-circle" />
          <div className="gap-20" />
          <p className="text-center">
            <strong>
              Su compromiso se realizado correctamente.
              </strong>
          </p>
          <div className="gap-20" />
          <p className="text-center">
            Te hemos enviado un email con el resumen de tu inversión.
          </p>
          <div className="gap-20" />
        </div>
      </div>
    );
  }
}

export default SuccessfulInvestmentComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/SuccessfulInvestment.component.tsx